export default {
  name: 'PreLoader'
}